import { createFileRoute, useParams } from '@tanstack/react-router'
import { ParceriasDrillDown } from '../../../app/financial/parcerias/drill-down'
import type { ParceriasAxis } from '@/api/parcerias-router.types'

function ParceriasDrillDownRoute() {
  const { axis, id } = useParams({ from: '/_auth/financial/parcerias/$axis/$id' })
  // Coerce route param to typed enum (route-level guard: anything not 'parceiro' falls back to 'cliente')
  const safeAxis: ParceriasAxis = axis === 'parceiro' ? 'parceiro' : 'cliente'
  return <ParceriasDrillDown axis={safeAxis} id={id} />
}

export const Route = createFileRoute('/_auth/financial/parcerias/$axis/$id')({
  component: ParceriasDrillDownRoute,
})
